import apiClient from './apiClient';

export interface DebtorDocument {
  id: number;
  debtor_id: number;
  document_type: string;
  document_name?: string;
  document_number?: string;
  file_url?: string;
  file_name?: string;
  file_size?: number;
  status: string;
  expiry_date?: string;
  notes?: string;
  uploaded_by?: string;
  created_at: string;
  updated_at: string;
  debtor_name?: string;
  debtor_cif?: string;
}

export interface DocumentFilters {
  debtor_id?: number;
  document_type?: string;
  status?: string;
}

const debtorDocumentApi = {
  getAll: (filters?: DocumentFilters) => {
    let endpoint = '/debtor-documents';
    if (filters) {
      const params = new URLSearchParams();
      Object.entries(filters).forEach(([key, value]) => {
        if (value) params.append(key, String(value));
      });
      const queryString = params.toString();
      if (queryString) endpoint += `?${queryString}`;
    }
    return apiClient.get<DebtorDocument[]>(endpoint);
  },

  getByDebtorId: (debtorId: number) => {
    return apiClient.get<DebtorDocument[]>(`/debtor-documents/debtor/${debtorId}`);
  },

  getById: (id: number) => {
    return apiClient.get<DebtorDocument>(`/debtor-documents/${id}`);
  },

  create: (data: Partial<DebtorDocument>) => {
    return apiClient.post<DebtorDocument>('/debtor-documents', data);
  },

  update: (id: number, data: Partial<DebtorDocument>) => {
    return apiClient.put<DebtorDocument>(`/debtor-documents/${id}`, data);
  },

  delete: (id: number) => {
    return apiClient.delete(`/debtor-documents/${id}`);
  },
};

export default debtorDocumentApi;
